import type { ViewerRole } from '../components/EngagementHub/roles';
import { statusBadgeTextFor, statusBadgeToneFor } from '../components/EngagementHub/status';
import { TONE_CLASSES } from '../components/shared/EngagementStatusBadge';

interface StatusBadgeProps {
  status: string;
  awaiting: string | null;
  viewerRole: ViewerRole;
  /** What governance sent back, for the viewer who owes the answer to it (§8.6). */
  governanceFeedbackKind?: 'adjustment' | 'rejection' | null;
  /**
   * Announce changes. Only for the one badge on a page that changes under the
   * reader: a list of live badges would announce every refetch.
   */
  live?: boolean;
}

/**
 * Live twin of `shared/EngagementStatusBadge`, which takes the prototype's
 * discriminated `Engagement`. Same tone map and same copy table (both imported,
 * not re-declared) — only the input shape differs.
 */
export default function StatusBadge({
  status,
  awaiting,
  viewerRole,
  governanceFeedbackKind = null,
  live = false,
}: StatusBadgeProps): JSX.Element {
  const c = TONE_CLASSES[statusBadgeToneFor(status)];
  return (
    <span
      role={live ? 'status' : undefined}
      className={`inline-flex items-center gap-8 rounded-md border px-12 py-6 subtitle-1 ${c.bg} ${c.text} ${c.border}`}
    >
      <span className={`h-8 w-8 shrink-0 rounded-full ${c.dot}`} aria-hidden />
      {statusBadgeTextFor(status, awaiting, viewerRole, governanceFeedbackKind)}
    </span>
  );
}
